﻿import isBefore from 'date-fns/isBefore';
import compareAsc from 'date-fns/compareAsc';
import isSameDay from 'date-fns/isSameDay';
import isAfter from 'date-fns/isAfter';
import { IOrderListItem } from '../../../../Entities';
import compareDesc from 'date-fns/compareDesc';
import { IOrderCollection } from '../types';

export function findEarliestAvailableOrderPlacedAtDate(
    orderCollections: IOrderCollection[]
): Date | null {
    if (orderCollections.length === 0) {
        return null;
    }

    return orderCollections.reduce((earliestAvailableDate, orderCollection) => {
        orderCollection.orders.forEach((order) => {
            const orderPlacedAt = new Date(order.orderPlacedAt);

            if (isBefore(orderPlacedAt, earliestAvailableDate)) {
                earliestAvailableDate = orderPlacedAt;
            }
        });

        return earliestAvailableDate;
    }, new Date());
}

export function hasDateChanged(currentDate: Date, previousDate: Date): boolean {
    return compareAsc(currentDate, previousDate) !== 0;
}

export function shouldRequestOrdersWithNewDate(
    currentStartDate: Date | null,
    previousStartDate: Date | null,
    currentEndDate: Date | null,
    previousEndDate: Date | null
): boolean {
    return (
        currentStartDate !== null &&
        currentEndDate !== null &&
        (hasDateChanged(currentStartDate, previousStartDate) ||
            hasDateChanged(currentEndDate, previousEndDate))
    );
}

export function validateStartDateInAvailableDateRange(
    startDate: Date,
    earliestAvailableDate: Date
): boolean {
    const now = new Date(Date.now());
    return (
        isSameDay(startDate, now) ||
        isSameDay(startDate, earliestAvailableDate) ||
        (isAfter(startDate, earliestAvailableDate) && isBefore(startDate, now))
    );
}

export function validateEndDateInAvailableDateRange(
    endDate: Date,
    startDate: Date | null,
    earliestAvailableDate: Date
): boolean {
    const now = new Date(Date.now());

    if (startDate === null) {
        return (
            isSameDay(endDate, now) ||
            isSameDay(endDate, earliestAvailableDate) ||
            (isAfter(endDate, earliestAvailableDate) && isBefore(endDate, now))
        );
    }

    return (
        isSameDay(endDate, now) ||
        isSameDay(endDate, startDate) ||
        (isAfter(endDate, startDate) && isBefore(endDate, now))
    );
}

export function sortOrdersByDateDesc(
    firstOrder: IOrderListItem,
    secondOrder: IOrderListItem
): number {
    return compareDesc(new Date(firstOrder.orderPlacedAt), new Date(secondOrder.orderPlacedAt));
}

export function sortOrderCollectionsByLastOrderPlacedAtDesc(
    firstCollection: IOrderCollection,
    secondOrderCollection: IOrderCollection
): number {
    return compareDesc(
        new Date(firstCollection.lastOrderPlacedAt),
        new Date(secondOrderCollection.lastOrderPlacedAt)
    );
}
